import { injectable } from '@patsnap/tahiti-core/shared/inversify'
import type { IControl } from '@eureka/utils/control'
import type { AgentUploadLimitStrategy } from './agent-upload-limit-strategy'

@injectable()
export class PdaUploadLimitStrategy implements AgentUploadLimitStrategy {
    getLimit(controlInfo?: IControl): number {
        if (controlInfo?.ls_role) return 10
        if (controlInfo?.ls_plg_role === 'personal_pro') return 5
        if (controlInfo?.ls_plg_role === 'personal_basic') return 2
        return 2
    }
}
